module.exports = __webpack_public_path__ + "img/486.24298f5e.jpg";